import { PartnerAriaLabels } from '@com-delta-omnichannel/aura';
import { AEMpartner } from '../models/partners-personalization-engine.interfaces';
import {
  EnrolledPromotion,
  PartnersPromotionsResponse
} from '../models/partners-promotions.interfaces';
import { Params } from '../models/partners.constants';

export const getPartnerAriaLabels = (
  aemPartner: AEMpartner
): PartnerAriaLabels => {
  return {
    action: aemPartner.ctaAriaLabel
      ? aemPartner?.ctaAriaLabel + ' ' + aemPartner.ctaLabel
      : ''
  };
};

export const getDate = (date: string): string => {
  return new Date(date + 'T12:00:00Z').toLocaleDateString(Params.LOCALE, {
    day: Params.TWO_DIGIT,
    month: Params.TWO_DIGIT,
    year: Params.TWO_DIGIT
  });
};

export const getEnrollPromotions = (
  promotion: PartnersPromotionsResponse
): EnrolledPromotion[] => {
  return promotion.enrolledTotalCount > 0 ? promotion.enrolledPromotions : [];
};
